import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import {
	Icon,
	Url,
	TEXT_ALIGNMENT_OPTIONS,
	TextAlignmentOptions,
	IMAGE_ALIGNMENT_OPTIONS,
	ImageAlignmentOptions,
} from '#const';
import { getIconUrl } from '#utils';

const SecondaryHero = dynamic(() => import('./SecondaryHero'));

Builder.registerComponent(SecondaryHero, {
	name: 'SecondaryHero',
	inputs: [
		{
			name: 'heading',
			friendlyName: 'Heading',
			type: 'richText',
			required: true,
			defaultValue: '<h3>Placeholder heading: <u>Time is limited</u> to File!</h3>',
		},
		{
			name: 'headingAlignment',
			friendlyName: 'Heading Alignment',
			type: 'string',
			enum: [...TEXT_ALIGNMENT_OPTIONS],
			defaultValue: TextAlignmentOptions.LEFT,
			helperText: 'Optional text alignment for the heading.',
		},
		{
			name: 'copy',
			friendlyName: 'Text',
			type: 'richText',
			required: true,
			defaultValue: '<p>Placeholder body text.</p>',
		},
		{
			name: 'copyAlignment',
			friendlyName: 'Text Alignment',
			type: 'string',
			enum: [...TEXT_ALIGNMENT_OPTIONS],
			defaultValue: TextAlignmentOptions.LEFT,
			helperText: 'Optional text alignment for the body text.',
		},
		{
			name: 'line',
			friendlyName: 'Dividing Line',
			type: 'boolean',
			helperText: `Include dividing line under the headline?
				Color of line is set by the page secondary accent color.`,
		},
		{
			name: 'color',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: '#F9FAFB',
			helperText: 'Be sure to select a color light enough for the text to have contrast.',
		},
		{
			name: 'image',
			friendlyName: 'Image',
			type: 'object',
			required: false,
			helperText: 'Optional image placed depending on the Image Layout.',
			defaultValue: {
				src: Url.PLACEHOLDER,
				alt: '',
			},
			subFields: [
				{
					name: 'src',
					friendlyName: 'Image',
					type: 'file',
					allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
				},
				{
					name: 'alt',
					friendlyName: 'Alt Text',
					type: 'string',
					helperText: 'Briefly describe the image for accessibility.',
				},
			],
		},
		{
			name: 'imageLayout',
			friendlyName: 'Image Layout',
			type: 'string',
			enum: [...IMAGE_ALIGNMENT_OPTIONS],
			defaultValue: ImageAlignmentOptions.TOP,
			helperText: 'Optional alignment for the Image. Above or below the body text',
		},
		{
			name: 'textBox',
			friendlyName: 'Box around Content',
			type: 'boolean',
			defaultValue: false,
			helperText: `Give content a transparent background box, to make text more legible over
				background colors. Box border color is set by the page secondary accent color.`,
		},
	],
	canHaveChildren: true,
	defaultChildren: [
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'Button',
				options: {
					copy: 'See if I Qualify',
					arrow: true,
					color: 'rgba(17, 186, 0, 1)',
				},
			},
		},
	],
	childRequirements: {
		message: 'Child must be a Button.',
		query: { 'component.name': { $eq: 'Button' } },
	},
	image: getIconUrl(Icon.SECONDARY_HERO),
});
